import AiBloggerTabs from './AiBloggerTabs';
import AiBlogger from './AiBlogger';
import { useState } from 'react';

export default function AiBloggerTab({ open, status }) {
  const [refetchCredits, setRefetchCredits] = useState(false);

  const handleRefetchCredits = async () => {
    setRefetchCredits(true);
    await new Promise(r => setTimeout(r, 500));
    setRefetchCredits(false);
  };

  return (
    <AiBloggerTabs
      refetchCredits={refetchCredits}
      activeTab={0}
      open={open}
      content={
        <>
          <AiBlogger
            status={status}
            handleRefetchCredits={handleRefetchCredits}
          />
        </>
      }
    />
  );
}
